import React, { useContext } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./Dot.scss";
import { ThemeContext } from "../Theme";

export const Dot = ({ active, className, ...props }) => {
  const theme = useContext(ThemeContext);

  return (
    <span
      className={cx(
        styles.dot,
        active && styles.active,
        styles[theme],
        className
      )}
      {...props}
    />
  );
};

Dot.defaultProps = {
  active: false,
  className: undefined,
};

Dot.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
};

Dot.displayName = "Dot";

export default Dot;
